import { render, staticRenderFns } from "./tpl-8.vue?vue&type=template&id=15e01381&scoped=true"
import script from "./tpl-8.vue?vue&type=script&lang=js"
export * from "./tpl-8.vue?vue&type=script&lang=js"
import style0 from "./tpl-8.vue?vue&type=style&index=0&id=15e01381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e01381",
  null
  
)

export default component.exports